export enum AnalysisPageType {
  Summary = "Summary",
  Overview = "Overview",
  Dashboard = "Dashboard",
  Topics = "Topics",
  Comments = "Comments",
}
